import { Link } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';
import DayOneLogo from 'components/DayOneLogo';
import FancyHandsLogo, { FLogo } from 'components/FancyHandsLogo';

export function SmallLogo () {
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <FLogo />
            <DayOneLogo fontSize="24pt" />
        </Stack>
    );
}
export default function CombinedLogo ( {size=undefined }: {size?: "xs" | "sm" | "standard" | undefined}) {
    const dayOnefontSize = size === "xs" ? "16pt" : size === "sm" ? "20pt" : "24pt";
    return (
        <Stack
            direction={(size == 'xs' ? 'column' : 'row')}
            ml={{ xs: 1 }}>

            <Stack direction="row"
                alignItems="center"
                justifyContent="flex-start">
                <DayOneLogo fontSize={dayOnefontSize} />
            </Stack>

            <Stack direction="row">
                <Typography
                    level="body-xs"
                    mt={ size == 'xs' ? 0 : { xs: 1 } }
                    pl={ size == 'xs' ? 0 : { xs: 1 } }
                    pr={1}>By</Typography>

                <Box
                    sx={{
                        width: (size == 'xs' ? 75 : { xs: 100 }),
                        mt: (size == 'xs' ? 0 : { xs: 1 })
                    }}
                >
                <Link to={"/"}>
                { size == 'standard' ? <FLogo /> : <FancyHandsLogo /> }
                    </Link>
                </Box>

            </Stack>
        </Stack>
    );
}
